<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="赛事成长闭环" en="Closed-Loop Growth " type="1"></pageTitle>
      <div class="common-title-d1 mt-20">本大会构建四步完整成长链路，层层递进为全球青少年PBL创新素养挑战赛蓄力；</div>
      <div class="common-title-d2 mt-12">This conference has established a complete four-step growth pathway, progressing layer by layer to build momentum for the Global Youth PBL Innovation Challenge.</div>
      <div class="page-flex-lr-center-between mt-20">
        <img :src="$env.imgUrl + 'explore1-s1-1.png'" alt="">
        <img :src="$env.imgUrl + 'explore1-s1-2.png'" alt="">
        <img :src="$env.imgUrl + 'explore1-s1-3.png'" alt="">
        <img :src="$env.imgUrl + 'explore1-s1-4.png'" alt="">
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="探究方案推荐" en="Recommended Inquiry Plans" type="2"></pageTitle>
        <div class="common-title-d3 mt-20">四大主题实地探究方案面向全国中小学及全球青少年开放。</div>
        <div class="common-title-d4 mt-12">The four thematic field exploration programs are open to primary and secondary schools nationwide as well as young people worldwide.</div>
        <img :src="$env.imgUrl + 'explore1-s2.png'" alt="">
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <div class="tit-cn">四大主题探究方案推荐</div>
        <div class="tit-en">Recommended Study Tour Programs on Four Major Themes</div>
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">主题</div>
                <div class="en">Theme</div>
              </div>
              <div class="value1">
                <div class="cn">非遗人文素养</div>
                <div class="en">Intangible cultural heritage and humanistic literacy</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">推荐地区/路线</div>
                <div class="en">Recommended regions/routes</div>
              </div>
              <div class="value2">
                <div class="cn">马来西亚—新加坡（7天6晚已定制项目）</div>
                <div class="en">Malaysia - Singapore (7 days and 6 nights customized program)</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">核心探究内容</div>
                <div class="en">Core exploration content</div>
              </div>
              <div class="value3">
                <div class="cn">学生将在马六甲与槟城世界文化遗产地对比观察马来、华族、印度及欧亚文化在建筑、饮食、传统技艺中的交融与变异，同时在新加坡多元种族社区探究非遗如何在高度现代化的城市国家中实现活态传承与创新转化。项目结合联合国SDG 11（可持续城市与社区），引导学生思考文化遗产保护与城市发展的平衡之道，并通过在地非遗工坊实践，提出面向社区的活化建议。</div>
                <div class="en">Students will observe and compare the blending and variation of Malay, Chinese, Indian, and Eurasian cultures in architecture, cuisine, and traditional craftsmanship at the World Cultural Heritage sites in Malacca and Penang. At the same time, they will explore how intangible cultural heritage is preserved and innovatively transformed in a highly modernized city-state within the multiracial community of Singapore. The project combines United Nations SDG 11 (Sustainable Cities and Communities) to guide students to consider the balance between cultural heritage protection and urban development. Through hands-on experience at local intangible cultural heritage workshops, students will propose community-oriented revitalization suggestions.</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">预期素养提升</div>
                <div class="en">Expected Improvement in Competencies</div>
              </div>
              <div class="value2">
                <div class="cn">跨文化理解力、全球视野、文化传承责任感</div>
                <div class="en">Cross-cultural understanding, global perspective, and a sense of responsibility for cultural inheritance</div>
              </div>
            </div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'explore1-s3.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section4 red-bg" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">主题</div>
                <div class="en">Theme</div>
              </div>
              <div class="value1">
                <div class="cn">海洋科学素养</div>
                <div class="en">Marine science literacy</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">推荐地区/路线</div>
                <div class="en">Recommended regions/routes</div>
              </div>
              <div class="value2">
                <div class="cn">青岛—厦门（中国）</div>
                <div class="en">Qingdao - Xiamen (China)</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">核心探究内容</div>
                <div class="en">Core exploration content</div>
              </div>
              <div class="value3">
                <div class="cn">学生可在国内从黄海到南海，对比不同纬度海域的海洋生态系统与生物多样性特征，深入中科院海洋研究所、国家深海基地及自然资源部第三海洋研究所，了解中国在深海探测、珊瑚礁保护等领域的在地化科研实践；亦可远赴挪威探索可持续海洋管理与峡湾生态，或在澳大利亚大堡礁参与珊瑚白化监测项目。通过国内外海洋治理模式的跨文化对比，紧扣SDG 14（水下生物），引导学生评估人类活动对海洋的影响，并设计面向社区的海洋保护行动方案。</div>
                <div class="en">Students can compare the marine ecosystems and biodiversity characteristics of waters at different latitudes, from the Yellow Sea to the South China Sea, within China. They can also visit the Institute of Oceanology, Chinese Academy of Sciences, the National Deep-Sea Base, and the Third Institute of Oceanography, Ministry of Natural Resources, to learn about China's localized scientific research practices in deep-sea exploration and coral reef protection. Alternatively, students can travel to Norway to explore sustainable ocean management and fjord ecology, or participate in coral bleaching monitoring projects in the Great Barrier Reef of Australia. Through cross-cultural comparisons of marine governance models at home and abroad, and closely related to SDG 14 (underwater life), students are guided to assess the impact of human activities on the ocean and design community-oriented marine protection action plans.</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">预期素养提升</div>
                <div class="en">Expected Improvement in Competencies</div>
              </div>
              <div class="value2">
                <div class="cn">海洋生态系统认知、科考方法、生态责任感</div>
                <div class="en">Marine ecosystem cognition, scientific research methods, ecological responsibility</div>
              </div>
            </div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'explore1-s4.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section5">
      <div class="safe-area">
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">主题</div>
                <div class="en">Theme</div>
              </div>
              <div class="value1">
                <div class="cn">AI科创素养</div>
                <div class="en">AI Innovation Literacy</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">推荐地区/路线</div>
                <div class="en">Recommended regions/routes</div>
              </div>
              <div class="value2">
                <div class="cn">深圳（中国）</div>
                <div class="en">Shenzhen (China)</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">核心探究内容</div>
                <div class="en">Core exploration content</div>
              </div>
              <div class="value3">
                <div class="cn">学生可在深圳深入大疆、华为、优必选等领军企业，理解AI与制造业及创新创业生态的在地化耦合，并对比美国硅谷在基础算法与商业应用上的领先优势，以及以色列特拉维夫在网络安全与农业科技领域的独特创新模式。聚焦SDG 9（产业、创新与基础设施）与SDG 11（可持续城市），引导学生探究AI在不同社会制度与文化背景下面临的伦理差异，并完成一项具有社会包容性价值的AI应用方案设计，例如智慧无障碍设施或社区应急响应系统。</div>
                <div class="en">Students can gain insights into leading enterprises such as DJI, Huawei, and UBTECH in Shenzhen, understand the localized integration of AI with manufacturing and the innovation and entrepreneurship ecosystem, and compare the leading edge of Silicon Valley in the United States in basic algorithms and commercial applications, as well as the unique innovation model of Tel Aviv in Israel in the fields of cybersecurity and agricultural technology. Focusing on SDG 9 (Industry, Innovation, and Infrastructure) and SDG 11 (Sustainable Cities), students will be guided to explore the ethical differences faced by AI under different social systems and cultural backgrounds, and complete the design of an AI application scheme with social inclusivity value, such as smart barrier-free facilities or community emergency response systems.</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">预期素养提升</div>
                <div class="en">Expected Improvement in Competencies</div>
              </div>
              <div class="value2">
                <div class="cn">编程能力、创新思维、前沿科技全局认知</div>
                <div class="en">Programming ability, innovative thinking, and comprehensive understanding of cutting-edge technology</div>
              </div>
            </div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'explore1-s5.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section6 red-bg" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">主题</div>
                <div class="en">Theme</div>
              </div>
              <div class="value1">
                <div class="cn">PBL财商素养</div>
                <div class="en">PBL Financial Literacy</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">推荐地区/路线</div>
                <div class="en">Recommended regions/routes</div>
              </div>
              <div class="value2">
                <div class="cn">新加坡</div>
                <div class="en">Singapore</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">核心探究内容</div>
                <div class="en">Core exploration content</div>
              </div>
              <div class="value3">
                <div class="cn">学生可在上海陆家嘴金融贸易区观察中国特色的绿色金融与数字货币实践，亦可前往新加坡对比其与香港、伦敦等国际金融中心在监管框架与财富管理模式上的异同。通过参访新加坡金融管理局、渣打银行及城市重建局，理解金融治理与国土规划的在地化协同逻辑。围绕SDG 8（体面工作与经济增长）及SDG 13（气候行动），引导学生设计一项兼具财务可持续性与环境社会效益的绿色金融产品或社区经济计划，培养解决真实世界财经问题的能力。</div>
                <div class="en">Students can observe the practice of green finance and digital currency with Chinese characteristics in the Lujiazui Finance and Trade Zone in Shanghai, and also visit Singapore to compare its regulatory framework and wealth management model with those of international financial centers such as Hong Kong and London. By visiting the Monetary Authority of Singapore, Standard Chartered Bank, and the Urban Redevelopment Authority, students can understand the localized collaborative logic of financial governance and territorial planning. Focusing on SDG 8 (decent work and economic growth) and SDG 13 (climate action), students are guided to design a green financial product or community economic plan that combines financial sustainability with environmental and social benefits, cultivating their ability to solve real-world financial problems.</div>
              </div>
            </div>
            <div class="page-flex-lr-top mb-14">
              <div class="label">
                <div class="cn">预期素养提升</div>
                <div class="en">Expected Improvement in Competencies</div>
              </div>
              <div class="value2">
                <div class="cn">财经知识、金融逻辑、跨界商业思维</div>
                <div class="en">Financial knowledge, financial logic, cross-industry business thinking</div>
              </div>
            </div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'explore1-s6.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section7 safe-area">
      <div class="tit-cn">补充说明</div>
      <div class="tit-en">Additional Notes</div>
      <div class="page-flex-lr-center-between mt-20">
        <img :src="$env.imgUrl + 'explore1-s7-1.png'" alt="">
        <img :src="$env.imgUrl + 'explore1-s7-2.png'" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="less">
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  img{
    width: 24%;
  }
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img{
    width: 100%;
    margin-top: 20px;
  }
}
.section3 {
  padding: 20px 0 60px;
  .lf{
    width: 55%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section4 {
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 55%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section5 {
  padding: 20px 0 60px;
  .lf{
    width: 55%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section6 {
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 55%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.tit-cn{
  font-family: systh;
  font-size: 18px;
  color: #000;
}
.tit-en{
  font-family: systm;
  font-size: 10px;
  color: #999;
  margin-bottom: 20px;
}

.label{
  background-color: #C9273A;
  color: #fff;
  padding: 8px 10px;
  border-radius: 8px;
  margin-right: 20px;
  text-align: center;
  width: 100px;
  .cn{
    font-family: alih;
    font-size: 12px;
    line-height: 16px;
  }
  .en{
    font-size: 9px;
    line-height: 9px;
  }
}
.value1{
  flex: 1;
  .cn{
    font-family: systh;
    font-size: 16px;
    color: #000;
  }
  .en{
    font-family: systm;
    font-size: 10px;
    color: #999;
  }
}
.value2{
  flex: 1;
  .cn{
    font-family: systm;
    font-size: 14px;
    color: #000;
  }
  .en{
    font-family: systm;
    font-size: 10px;
    color: #999;
    text-align: justify;
  }
}
.value3{
  flex: 1;
  .cn{
    font-family: systm;
    font-size: 12px;
    color: #000;
  }
  .en{
    font-family: systm;
    font-size: 10px;
    color: #999;
    text-align: justify;
  }
}
.mb-14{
  margin-bottom: 14px;
}
.red-bg {
  .label{
    background-color: #fff;
    color: #C9273A;
  }
  .value1, .value2, .value3{
    .cn{
      color: #fff !important;
    }
    .en{
      color: #FD8E86 !important;
    }
  }
}

.section7{
  padding-bottom: 40px;
  img{
    width: 49%;
  }
}
</style>
